import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PageRequest, PaginationPage } from 'src/app/common/modules/data-table.module/interfaces';
import { Doctor } from 'src/app/entities/user.entity/doctor.entity';
import { AuthService } from 'src/app/services/auth.service/auth.service';
import { ConsultationService } from 'src/app/services/consultation.service';
import { ConsultationDto } from '../../Resovler/ConsultationDto';
import { environment } from 'src/environments/environment';
import { AssistanceServiceService } from 'src/app/services/assistance.service/assistance-service.service';
import { Assistance } from 'src/app/entities/user.entity/doctor.entity/assistance.entity';

@Component({
  selector: 'app-assistance-consultation-table',
  templateUrl: './assistance-consultation-table.component.html',
  styleUrls: ['./assistance-consultation-table.component.css']
})
export class AssistanceConsultationTableComponent implements OnInit {

  @Input() currentPage: number = 0;
  @Input() perPage: number = 10;
  @Input() pageRequest!: (pageRequest: PageRequest) => Promise<PaginationPage<ConsultationDto>>;
  @Input() emptyMessage?: string;

  doctorConsultations: ConsultationDto[] = [];

  assistanceMap: { [key: number]: string } = {};
usersList: any[] = [];
@Input() selectedUser: string="";
@Output() selectedUserChange: EventEmitter<string> = new EventEmitter<string>();
  constructor(
    private consultationsService: ConsultationService,
    private authService: AuthService,
    private toasterService: ToastrService,
    private assistanceService: AssistanceServiceService
  ) { }

  get user(): Assistance  {
    return this.authService.getCurrentUser() as Assistance;
  }

  ngOnInit(): void {
    this.currentPage = 0;
    this.getAssistants();
  }

  getAssistants(): void {

  this.assistanceService.getAssistantList().subscribe({
    next: (res: any) => {

      const medecin = {
        ...res.medecin,
        type: 'DOCTOR'
      };

      const assistants = res.assistants.map((a: any) => ({
        ...a,
        type: 'ASSISTANT'
      }));

      this.usersList = [medecin, ...assistants];

      // ✅ remplir assistanceMap
      this.usersList.forEach((assistant: any) => {

        this.assistanceMap[assistant.id] =
          assistant.firstName + ' ' + assistant.lastName;

      });


    }
  });
}

  getAssistanceName(consultation: ConsultationDto): string {
    if (!consultation?.consultationShareid) {
      return this.user.doctor.firstName + ' ' + this.user.doctor.lastName || 'N/A';
    }
    return this.assistanceMap[consultation.consultationShareid] ;
  }

  avatarSrc(consultation: ConsultationDto): string {

    return consultation.patientImage
      ? `http${environment.API_SSL ? 's' : ''}://${environment.API_HOST_NAME}${environment.PORT ? ':' + environment.PORT : ''}/${environment.STORAGE_ENDPOINT}/${consultation.patientImage}`
      : 'assets/img/user-avatar.png';
  }

  onDeleteConsultation(index: number): void {

    if (confirm('Êtes-vous sûr(e) de vouloir supprimer cette   consultation ?')) {

      this.consultationsService.delete(this.doctorConsultations[index].id)
        .subscribe({
          next: () => {
            this.toasterService.success('Consultation has deleted');
            this.doctorConsultations.splice(index, 1);
          },
          error: () => {
            this.toasterService.error('Enable to delete Consultation');
          }
        });
    }
  }
}